import React from 'react'
import PropTypes from 'prop-types'

import Label from '../label'

class InputError extends React.Component {
    static propTypes = {
        message: PropTypes.string
    }

    render(){
        let { message='app.err.input' } = this.props;
        return this.props.visible ? <Label>{message}</Label> : <div />
    }
}


export default InputError
